import { graphql } from "react-relay";

export const QUERY = graphql`
	query offerSubscriptions_Query($first: Int) {
		Admin {
			Offer {
				mySubscriptions(first: $first) {
					edges {
						node {
							offerId
							owner
							offerTitle
							versionInUse
							latestVersion
							updateAvailable
							config {
								title
								image {
									id
									url
								}
								visibilityConfigs {
									configType
									... on AfterDateTimeVisibilityTreeConfig {
										dateTime
									}
									... on NotAfterDateTimeVisibilityTreeConfig {
										dateTime
									}
								}
								selectedVersion
								licenseProduct {
									id
									title
								}
								courseContentProduct {
									id
									title
								}
								certificationProduct {
									id
									title
								}
							}
						}
					}
				}
			}
		}
	}
`;
